/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'telegram-round-white': {
    width: 30,
    height: 30,
    viewBox: '0 0 30 30',
    data:
      '<g _fill="none"><circle pid="0" cx="14.961" cy="14.961" r="13.961" _stroke="#ECF8FD" stroke-width="2"/><path pid="1" _fill="#C2DAEC" d="M10.007 16.164l1.736 4.678 7.619-10.618z"/><path pid="2" _fill="#9FCDE2" d="M11.921 17.21l-.158 3.672 4.026-3.415z"/><path pid="3" _fill="#ECF8FD" d="M21.237 8.447l-15.04 5.724c-.434.158-.414.77.02.908l3.888 1.303 8.842-5.704-7.006 6.533 5.447 4.125a.989.989 0 0 0 1.56-.553L21.887 9c.08-.375-.296-.71-.651-.553z"/></g>'
  }
})
